import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { VideoService } from '../shared/services/video.service'
import { catchError } from 'rxjs/operators'

@Injectable()
export class VideosResolver implements Resolve<{}> {
  constructor(private videoService: VideoService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.videoService.getVideoBySlug(route.params).pipe(catchError(err => of({})))
  }
}
